import { DefaultError, QueryClient, UseQueryOptions, useQuery } from '@tanstack/react-query';
import { getLogger } from '@/utils/loglevel';

import { QueryKeys } from '../api/query-keys';
import { post } from '../api/api.helpers';
import { VALIDATOR_URL } from '@/constants';

const logger = getLogger('useQueryRunesUtxos');

/*
{
  "outputs": [
    {
      "address": "string",
      "btc_amount": 9007199254740991,
      "script_hex": "string",
      "spent": true,
      "txid": "string",
      "unit_amount": 9007199254740991,
      "vout": 1073741824
    }
  ]
}
*/

type QueryRunesUtxosParams = {
  address: string | undefined;
};

export type UnitUtxoOutput = {
  address: string;
  btc_amount: number;
  script_hex: string;
  spent: boolean;
  txid: string;
  unit_amount: number;
  vout: number;
}

type UnitUtxoResponse = {
  outputs: UnitUtxoOutput[];
};

type QueryOptionsParam = Omit<UseQueryOptions<UnitUtxoResponse, DefaultError>, 'queryKey' | 'queryFn'>;

const url = `${VALIDATOR_URL}/api/unit_utxos_by_address`;
export function fetchRuneUtxos(address: string): Promise<UnitUtxoResponse> {
  return post(url, { address });
}

export function useQueryRuneUtxos(params: QueryRunesUtxosParams, options?: QueryOptionsParam) {
  const queryKey = [QueryKeys.walletRunes, params.address];

  return useQuery({
    queryKey,
    queryFn: async () => {
      if (!params.address) {
        throw new Error('Address is required');
      }
      const result = await fetchRuneUtxos(params.address);
      logger.debug('result', result);

      return result;
    },
    enabled: !!params.address,
    ...options,
  });
}

export function invalidateRuneUtxos(queryClient: QueryClient) {
  queryClient.invalidateQueries({ queryKey: [QueryKeys.walletRunes] });
}
